import React, { useState, useRef, useEffect } from "react";
import { AiFillCloseCircle, AiOutlineCopy } from "react-icons/ai";
import { IoTicketOutline } from "react-icons/io5";
import { apiPostPut } from "../../api/api_methods";
import { useNavigate } from "react-router-dom";
import RazorPayGateway from "../payment/razor_pay";
import { RedeemCoupon } from "./basicDetails";
import { useStores } from "../../store";
import { FaRupeeSign } from "react-icons/fa";
import Tooltip from "../reusble_components/tooltip";
import { useObserver } from "mobx-react";
import { FaArrowLeftLong } from "react-icons/fa6";
const CreditPoints = ({ availableCredits, totalCredits }) => {
  const [showRedeemPop, setshowRedeemPop] = useState(false); // to show the redeem popup
  const [popup, setPopup] = useState(true);
  // const totalcredits = totalCredits ?? 500;
  const totalcredits = availableCredits;
  const userDetails = JSON.parse(localStorage.getItem("user"));
  const coins = availableCredits ?? userDetails?.coins;
  const percentage = (coins / totalcredits) * 100;
  // console.log(percentage);
  const [showPurchaseCredits, setshowPurchaseCredits] = useState(false);

  const navigate = useNavigate();

  const handlePopup = () => {
    setshowRedeemPop(!showRedeemPop);
  };

  const { PopupStore } = useStores();

  return useObserver(() => (
    <>
      <div className="flex flex-col md:mt-[0%] mr-auto mt-3 lg:w-[50%] w-full md:w-[50%]">
        {showPurchaseCredits && (
          <PurchaseCredits onClose={() => setshowPurchaseCredits(false)} />
        )}
        {/* <div className="flex justify-between w-full items-center">
          <div className="flex justify-between w-full items-center">
            <p className="md:text-xl text-text_color3 text-left lg:text-2xl">
              Credit Points */}
        {/* <button className="ml-2 text-sm bg-primary rounded-lg text-white p-2"  onClick={() => navigate('/company/view-credits')}>View Credits</button> */}
        {/* </p>
            <p
              className="text-right text-xs md:hidden lg:hidden flex items-center gap-1 w-20  ml-auto cursor-pointer lg:text-3xl "
              onClick={() => {
                PopupStore.setKnowMore(true);
              }}
            >
              {" "}
              <AiOutlineInfoCircle />
              <span className="lg:text-md "> Know more </span>
            </p>
          </div>
          <button
            onClick={() => setshowRedeemPop(true)}
            className="md:flex lg:flex hidden items-center justify-center text-black underline"
          >
            <MdOutlineAddCircle className="text-primary text-xl" /> Add Credits
          </button>
        </div> */}

        {/* <div class="mt-[5%] h-[6.5vh]  rounded-full  overflow-hidden border-2 md:w-[100%] lg:w-[100%] w-[85vw] bg-primary2">
          <div
            class=" bg-primary h-[6vh] rounded-l-[10.37px]  "
            style={{ width: `${percentage + "%"}` }}
          >
            {" "}
          </div>
          <p className="relative md:text-lg font-bold mt-[-35px] text-center text-text_color3 ">
            {" "}
            {coins}
          </p>
        </div> */}

        <Tooltip
          id="creditpoinstooltip"
          position="bottom"
          content="Your credit points"
        >
          {/* <div className="mt-[5%]  h-[5.7vh] relative overflow-hidden rounded-full flex  w-[95%] mb-2 border-2 border-primary">
            <div
              class=" bg-primary  h-[6vh] rounded-l-[10.37px]   "
              style={{ width: `${percentage + "%"}` }}
            >
              {" "}
            </div>
            <p className=" absolute w-full h-full   md:text-base font-bold  text-center text-black flex justify-center items-center lg: text-3xl">
              <TbCoins className="text-3xl" />
              <span>{coins}</span>
            </p>
          </div> */}
        </Tooltip>

        {/* <span
        className="cursor-pointer"
        onClick={() => setshowPurchaseCredits(true)}
      >
        Buy more
      </span> */}
      </div>
      {showRedeemPop ? (
        <RedeemCoupon popUpInitialValue={popup} handlePopup={handlePopup} />
      ) : null}
    </>
  ));
};

export default CreditPoints;
export function PurchaseCredits({ onClose, gateWay = "razorPay" }) {
  const navigate = useNavigate();
  const [loading, setloading] = useState(false);
  const [showGateWay, setShowGateWay] = useState(false); // to show the payment gateway
  const [gateWayDetails, setGateWayDetails] = useState({}); // to store the payment gateway details
  const { PopupStore, InterviewStore } = useStores();

  const [paymentUrl, setpaymentUrl] = useState(null);

  const creditsRequiredRef = useRef(null); // to get the value of the input field

  const credits = creditsRequiredRef.current?.value;

  const handleGoBack = () => {
    PopupStore.setGetMoreCredits(true);
    PopupStore.setPaymentGateway(false);
  };

  useEffect(() => {
    if (creditsRequiredRef.current) {
      creditsRequiredRef.current.value = PopupStore.creditsPoints;
      console.log(PopupStore.creditsPoints);
      onSubmitForm();
    }
  }, [PopupStore.creditsPoints]);

  const onSubmitForm = async (e) => {
    let redirectUrl = window.location.href;
    localStorage.setItem("redirectUrl", redirectUrl);
    // alert(InterviewStore.redirectUrl);
    if (e) {
      e.preventDefault(); // Ensure `e` is defined before calling `preventDefault()`
    }
    // call axios api

    const credits =
      PopupStore.creditsPoints ?? creditsRequiredRef.current.value;
    console.log(credits);
    const userDetails = JSON.parse(localStorage.getItem("user"));
    const userId = userDetails?._id;
    const body = {
      userId,
      money: credits,
    };

    if (gateWay === "razorPay") {
      const url = "/razorpay/create-order";
      setloading(true);
      const response = await apiPostPut(body, url, "POST");
      setloading(false);
      console.log(response);
      if (response?.status === 200) {
        setGateWayDetails(response?.body?.data);
        setloading(true);
        setTimeout(() => {
          setShowGateWay(true);
          setloading(false);
        }, 1000);
        //  navigate(`/payment-razorpay/${orderId}`);
      }
    } else if (gateWay === "phonePe") {
      const url = "/v1/recruiter/payments/create-order";
      setloading(true);
      const response = await apiPostPut(body, url, "POST");
      setloading(false);
      console.log(response);
      if (response?.status === 200) {
        // open new tab
        const url = response?.body?.data?.paymentLink;
        console.log(url);
        setpaymentUrl(url);

        // const link = document.createElement("a");

        // // Set the href attribute
        // link.href = url;

        // // Set any other attributes as needed
        // // link.target = '_blank'; // Uncomment if you want to open in a new tab
        // // link.rel = 'noopener noreferrer'; // Uncomment for security (recommended for target="_blank")

        // // Append the anchor element to the body (or any other parent element)
        // document.body.appendChild(link);

        // // Simulate a click on the anchor element
        // link.click();

        // document.body.removeChild(link);

        // window.open(url, "_blank");
      }
    }
  };

  const handleCopyClick = () => {
    // Create a textarea element to temporarily hold the text
    const textarea = document.createElement("textarea");
    textarea.value = paymentUrl;

    // Append the textarea to the document
    document.body.appendChild(textarea);

    // Select the text in the textarea and copy it to the clipboard
    textarea.select();
    document.execCommand("copy");

    // Remove the textarea from the document
    document.body.removeChild(textarea);
  };

  return (
    <div
      onClick={onClose}
      className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="fixed inset-0 z-50 flex flex-col justify-center items-center md:w-[25vw] lg:w-[25vw] w-[90%] h-[65vh] m-auto  bg-bg3 "
      >
        <FaArrowLeftLong
          className="text-primary text-2xl cursor-pointer absolute top-4 left-4"
          onClick={handleGoBack}
        />
        <AiFillCloseCircle
          className="text-primary text-2xl cursor-pointer absolute top-4 right-4"
          onClick={onClose}
        />
        {!showGateWay ? (
          <>
            {" "}
            <div className="flex flex-col items-center justify-center w-[100%] h-full rounded-t  ">
              <IoTicketOutline className="text-primary  text-7xl border-b-2 border-bg3" />
              <p className="text-black font-semibold p-1 text-2xl">
                {" "}
                Credit Points
              </p>
              {/* <p className="text-black font-semibold mt-1 text-3xl">40% OFF</p>
        <p className="text-black  p-1 text-xl">Until dd/mm/year</p> */}
            </div>
            {paymentUrl && (
              <div className=" flex flex-col justify-around gap-4 relative items-center">
                <p className="flex items-end gap-2 font-medium text-base">
                  <p className="flex items-center">
                    <FaRupeeSign className="text-opacity-50" />
                    <p>{credits ?? PopupStore.creditsPoints}</p>{" "}
                    <p className="ml-2"> +</p>
                    <p className="ml-2">
                      {((credits ?? PopupStore.creditsPoints) * 0.18).toFixed(
                        2,
                      )}
                    </p>
                    <p className=" ml-2 opacity-60 ">(18% GST)</p>
                  </p>
                </p>
                <p className="flex items-center font-semibold">
                  <FaRupeeSign className="text-opacity-50" />
                  {((credits ?? PopupStore.creditsPoints) * 1.18).toFixed(2)}
                </p>

                <p className="flex justify-between px-2 py-2 rounded-lg w-60 border-2 mx-auto">
                  {" "}
                  <p className="w-[80%] truncate">{paymentUrl}</p>{" "}
                  <AiOutlineCopy
                    onClick={handleCopyClick}
                    className="cursor-pointer my-auto "
                  />{" "}
                </p>

                <a
                  href={paymentUrl}
                  // target="_blank"y y
                  className="text-center py-3 mb-28 px-3 bg-primary text-white font-semibold "
                  // rel="noopener noreferrer"
                >
                  Make a Payment
                </a>
                <p className=" w-80 text-yellow font-semibold text-right px-3 py-3 gap-3 absolute bottom-5 flex">
                  Note:{" "}
                  <p className="text-left">
                    {" "}
                    Use the button to make payment or copy link
                  </p>
                </p>
              </div>
            )}
            {!paymentUrl ? (
              <form
                onSubmit={onSubmitForm}
                className="flex flex-col items-center  bg-bg3 w-[100%] h-full  rounded-b "
              >
                {/* <p className="w-[90%] ">Hurry, our coupon expires on 01/01/2024. Don't miss out on the savings! Extend your savings by redeeming your coupon before 01/01/2024.</p> */}
                <input
                  ref={creditsRequiredRef}
                  type="number"
                  required
                  // min={50}
                  max={2000}
                  className="w-[50%] p-2 border border-border2  focus:outline-none"
                  placeholder="Enter credit points"
                />
                <button
                  disabled={loading}
                  type="submit"
                  className="mt-6 bg-primary2 hover:bg-primary text-lg text-primary font-semibold  hover:text-bg3 py-2 px-4 w-[55%] hover:border-transparent "
                >
                  {loading ? "Loading..." : "Purchase"}
                </button>
                <p className=" w-70 text-yellow font-semibold text-right px-3 py-3 gap-3 absolute bottom-5 flex">
                  Note: <p className="text-left"> One rupee per one credit</p>
                </p>
              </form>
            ) : null}
            <div></div>
          </>
        ) : (
          <RazorPayGateway
            orderId={gateWayDetails.id}
            amount={gateWayDetails.amount / 100}
          />
        )}
      </div>
    </div>
  );
}
